import React from "react";
import { useTransition, animated } from "react-spring";

const BottomSheet = ({ isOpen, options, onSelect, onClose }) => {
  const transitions = useTransition(isOpen, {
    from: { transform: "translate3d(0, 100%, 0)" },
    enter: { transform: "translate3d(0, 0%, 0)" },
    leave: { transform: "translate3d(0, 100%, 0)" }
  });

  return transitions(
    (styles, item) =>
      item && (
        <animated.div
          style={{
            ...styles,
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: "#fff",
            boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
            maxHeight: "60vh",
            overflowY: "auto",
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20
          }}>
          {options.map((option, index) => (
            <div
              key={index}
              onClick={() => onSelect(option)}
              style={{
                padding: "15px 30px",
                borderTop: "1px solid #eee",
                cursor: "pointer",
                color: "black",
                textTransform: "capitalize"
              }}>
              {option.name}
            </div>
          ))}
          <div
            onClick={onClose}
            style={{
              padding: 15,
              borderTop: "1px solid #eee",
              cursor: "pointer",
              textAlign: "center"
            }}>
            Close
          </div>
        </animated.div>
      )
  );
};

export default BottomSheet;
